import { Box } from '@mui/material';
import React from 'react';

const DetailsProgram = () => {
  return (
    <Box className="flex flex-col w-[max-content]">
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          La durabilité de l’économie tunisienne est améliorée et sa transition écologique est
          amorcée à travers le changement des comportements des consommateurs et des producteurs
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’Unité de Gestion par Objectifs pour la mise en œuvre de l’Accord de Paris{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">n.a</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Pas d'indicateur Programme
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’Unité de Gestion par Objectifs pour la mise en œuvre de l’Accord de Paris{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Une concertation politique et civique s’engage efficacement dans la lutte contre le
          changement climatique et la préservation des ressources naturelles.
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          1
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">0.1</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Au moins 4 nouvelles séries de données empiriquement robustes et sensibles au genre sur
          les indicateurs environnementaux et climatiques sont disponibles
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de maîtrise d’ouvrage Évaluation finale{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          1
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">0.2</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Au moins 4 stratégies ou politiques sont développées ou révisées par le biais de
          consultations et de la participation de différents groupes d'intérêt, pour la protection
          du climat et la conservation des ressources naturelles au cours de la période du projet
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de maîtrise d’ouvrage Évaluation finale{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Des progrès en matière environnementale découlent des investissements au niveau local.
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          2
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">i.2</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de collectivités territoriales utilisant le mécanisme LoCAL via les DAC et leur
          nombre de cycle(s) budgétaire(s) total{' '}
          <span className="text-red-500">(? cible LoCAL: 15, Programme: 10?)</span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de maîtrise d’ouvrage Évaluation finale{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Le secteur privé développe, seul ou en partenariat, des modes de production de biens et de
          gestion des services en phase avec les principes de l’économie verte et bleue.{' '}
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          2
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">OS1.1.1</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de PME financés dans le cadre du projet Greenov’i
          <span className="text-red-500">(? cible GREENOV'I: 210, Programme: 1000 ?)</span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports des entités responsables de la mise en œuvre; Enquête; Évaluation finale
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  "></div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          <span className="text-red-500"> ARESSE ???</span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports des entités responsables de la mise en œuvre; Enquête; Évaluation finale{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Le cadre législatif, réglementaire et normatif en matière d’environnement et de lutte
          contre le changement climatique est adapté et/ou mis en application.
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          1
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">1.1</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          {' '}
          Au moins 4 amendements réglementaires visant à mettre en œuvre les obligations de l'Accord
          de Paris et de la Convention sur la Diversité Biologique (CDB) sont élaborés et soumis au
          gouvernement pour adoption
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’opérateur choisi{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          1
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">1.2</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Au moins 2 nouveaux instruments visant à promouvoir la transition écologique de la Tunisie
          sont soumis au gouvernement pour adoption
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’opérateur choisi{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          1
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">1.3</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          3 secteurs sont couverts par des informations environnementales accessibles au public
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’opérateur choisi{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Des actions pour sensibiliser les citoyens et les entreprises sont mises en œuvre et
          contribuent à la prise de décision en matière environnementale.
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          1
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">2.1</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          1000 étudiant-e-s sensibilisé-e-s sur les questions environnementales, climatique et à la
          consommation durable <span className="text-green-500">(désagrégés par genre, âge) </span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’entité en charge de la coordination des actions vers la société civile{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          1
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">2.2</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          5 activités de sensibilisation des consommateurs sont mises en œuvre
          <span className="text-red-500"> (? cible PAGECTE: 5, Programme: 2 ?)</span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’entité en charge de la coordination des actions vers la société civile{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          1
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">3.1</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          <span className="text-red-500">
            {' '}
            5 actions de sensibilisation de grande envergure auxquelles les ONG participent
            activement sont mises en œuvre. NB : préciser que ONG doit être considéré comme
            entreprises
          </span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’entité en charge de la coordination des actions vers la société civile{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Les Plans d'action pour l'énergie durable et le climat (PAEDC) sont développés par les
          collectivités locales ciblées
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          2
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">i.4</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de collectivités locales dotées de PAEDC (ou équivalent) (a) élaborées ou (b)
          revues avec le soutien de l'UE (indicateur de base OPSYS)
          <span className="text-red-500">(? cible LoCAL: 22, Programme: 25 ?)</span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’opérateur et/recensement par le MALE{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Un système de financement des collectivités locales est mis en place pour les
          investissements à portée environnementale.
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          2
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">i.6</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de décisions administratives adaptant le cadre réglementaire pour le financement
          des communes
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’opérateur et/recensement par le MALE{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Des investissements pilotes en matière d'énergie durable et de lutte contre le changement
          climatique sont financés et réalisés dans les collectivités locales ciblées
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          2
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">i.9</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre d´investissements verts financés en matière d'énergie durable et de lutte contre le
          changement climatique des collectivités locales inscrits dans un PAEDC
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’opérateur et/recensement par le MALE{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Un dispositif d’accompagnement et de financement d’entreprises dans les secteurs de
          l’entrepreneuriat vert, de l’innovation verte (éco-innovation et technologies vertes), du
          tourisme durable, de l’économie circulaire est développé et mis en œuvre. Les modalités
          innovantes de financement et d’incitation à l’investissement sont mises en place
          (notamment, crowdfunding, subventions, prêts d’honneur, avances remboursables.)
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          3
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">OS1.1</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre d’opérateurs économiques soutenus, y compris financièrement, par les dispositifs
          développés avec l’appui de Greenov'i
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l'opérateur Enquête auprès des entreprises/éco-entrepreneurs{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          3
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">R1.2.1</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de structures intermédiaires soutenues pour l’accompagnement et le financement de
          l’entrepreneuriat vert
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l'opérateur Enquête auprès des entreprises/éco-entrepreneurs{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          3
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">OS1.1.2</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de mécanismes financiers verts développés/appuyés avec l’appui de l´UE
          <span className="text-red-500">(? cible GREENOV'I: 4, Programme: 2 ?) </span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l'opérateur Enquête auprès des entreprises/éco-entrepreneurs{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Une facilité pour financer l’insertion de chercheurs dans les collectivités locales et
          entreprises est mise en œuvre.
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          4
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">34</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de conventions MOBIDOC Post-Doc établies
          <span className="text-red-500">(? cible ARESSE: 200, Programme: 220 ?)</span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’agence nationale en charge de la promotion de la recherche scientifique{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          4
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">37</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de municipalités bénéficiaires du dispositif MOBIDOC
          <span className="text-red-500">(? cible ARESSE: 200, Programme: 220 ?)</span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’agence nationale en charge de la promotion de la recherche scientifique{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          4
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  "></div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          <span className="text-red-500">
            Aresse (pas d'indicateur spécifique, plusieurs indicaterus concernés)
          </span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’agence nationale en charge de la promotion de la recherche scientifique{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] bg-[#d9f2d0] h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[220px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[280px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate">
          Des initiatives pour accroître la recherche appliquée sont soutenues financièrement.
        </div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          4
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">27</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de projets financés pour une recherche scientifique appliquée dans le secteur de
          l’environnement
          <span className="text-red-500">(? cible ARESSE: 25-30, Programme: 15 ?) </span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’agence nationale en charge de la promotion de la recherche scientifique{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          4
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">28</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Nombre de centres de recherche impliqués dans les projets appliqués{' '}
          <span className="text-red-500">(cible: 15)</span> Nombre d’organismes socioéconomiques
          impliqués dans les projets appliqués{' '}
          <span className="text-red-500">(? cible ARESSE: 15+15=30, Programme: 80?) </span>
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’agence nationale en charge de la promotion de la recherche scientifique{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
      <div className="flex w-[max-content] border-b-2 h-[max-content]">
        <div className="w-[50px] h-full flex items-center justify-center text-xs font-bold capitalize">
          4
        </div>
        <div className="w-[180px] h-full flex items-center justify-center text-xs  ">17</div>
        <div className="w-[220px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Référentiel Métier-Référentiel Compétences (REMREC ) pour le secteur de l’environnement
        </div>
        <div className="w-[280px]  flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize">
          Rapports de l’agence nationale en charge de la promotion de la recherche scientifique{' '}
        </div>
        <div className="w-[180px] flex-col pl-[2px] h-full flex items-center justify-center text-xs capitalize"></div>
        <div className="w-[430px] pl-[2px] h-full  flex items-center justify-center text-xs capitalize two-line-truncate"></div>
      </div>
    </Box>
  );
};

export default DetailsProgram;
